import { render, staticRenderFns } from "./AdsCarousel.vue?vue&type=template&id=56927ae2&scoped=true&"
import script from "./AdsCarousel.vue?vue&type=script&lang=js&"
export * from "./AdsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./AdsCarousel.vue?vue&type=style&index=0&id=56927ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56927ae2",
  null
  
)

export default component.exports